export default __webpack_public_path__ + "media/images/loop3-77c345dfa7ac490b3651912d7dba2bb1.ico";